import {Button} from "react-bootstrap";
import {sendExpertData} from "../../../actions";
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";

const SendAnswer = ({item}) => {
    // @ts-ignore
    const form_type = useSelector(state => state.forms.form_type);
    const dispatch = useDispatch();

    // @ts-ignore
    return <Button
        bsStyle="primary"
        disabled={item.is_sent}
        onClick={() => {
            sendExpertData(form_type, item.id)(dispatch);
        }}
    >
        Отправить
    </Button>;
}

export default SendAnswer;